import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fa0eb0b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rendering" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RenderingRandselBody = _resolveComponent("RenderingRandselBody")!
  const _component_RenderingRandselSide = _resolveComponent("RenderingRandselSide")!
  const _component_RenderingRandselFront = _resolveComponent("RenderingRandselFront")!
  const _component_RenderingRandselEdge = _resolveComponent("RenderingRandselEdge")!
  const _component_RenderingRandselTack = _resolveComponent("RenderingRandselTack")!
  const _component_RenderingRandselBack = _resolveComponent("RenderingRandselBack")!
  const _component_RenderingRandselPocket = _resolveComponent("RenderingRandselPocket")!
  const _component_RenderingRandselInside = _resolveComponent("RenderingRandselInside")!
  const _component_RenderingRandselName = _resolveComponent("RenderingRandselName")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.cameraPos === 0)
      ? (_openBlock(), _createBlock(_component_RenderingRandselBody, {
          key: 0,
          cameraPos: _ctx.cameraPos
        }, null, 8, ["cameraPos"]))
      : _createCommentVNode("", true),
    (_ctx.cameraPos === 0)
      ? (_openBlock(), _createBlock(_component_RenderingRandselSide, {
          key: 1,
          cameraPos: _ctx.cameraPos
        }, null, 8, ["cameraPos"]))
      : _createCommentVNode("", true),
    (_ctx.cameraPos === 0)
      ? (_openBlock(), _createBlock(_component_RenderingRandselFront, {
          key: 2,
          cameraPos: _ctx.cameraPos
        }, null, 8, ["cameraPos"]))
      : _createCommentVNode("", true),
    (_ctx.cameraPos === 0)
      ? (_openBlock(), _createBlock(_component_RenderingRandselEdge, {
          key: 3,
          cameraPos: _ctx.cameraPos
        }, null, 8, ["cameraPos"]))
      : _createCommentVNode("", true),
    (_ctx.cameraPos === 0)
      ? (_openBlock(), _createBlock(_component_RenderingRandselTack, {
          key: 4,
          cameraPos: _ctx.cameraPos
        }, null, 8, ["cameraPos"]))
      : _createCommentVNode("", true),
    (_ctx.cameraPos === 0)
      ? (_openBlock(), _createBlock(_component_RenderingRandselBack, {
          key: 5,
          cameraPos: _ctx.cameraPos
        }, null, 8, ["cameraPos"]))
      : _createCommentVNode("", true),
    (_ctx.cameraPos === 1)
      ? (_openBlock(), _createBlock(_component_RenderingRandselBody, {
          key: 6,
          cameraPos: _ctx.cameraPos
        }, null, 8, ["cameraPos"]))
      : _createCommentVNode("", true),
    (_ctx.cameraPos === 1)
      ? (_openBlock(), _createBlock(_component_RenderingRandselPocket, {
          key: 7,
          cameraPos: _ctx.cameraPos
        }, null, 8, ["cameraPos"]))
      : _createCommentVNode("", true),
    (_ctx.cameraPos === 1)
      ? (_openBlock(), _createBlock(_component_RenderingRandselFront, {
          key: 8,
          cameraPos: _ctx.cameraPos
        }, null, 8, ["cameraPos"]))
      : _createCommentVNode("", true),
    (_ctx.cameraPos === 1)
      ? (_openBlock(), _createBlock(_component_RenderingRandselInside, {
          key: 9,
          cameraPos: _ctx.cameraPos
        }, null, 8, ["cameraPos"]))
      : _createCommentVNode("", true),
    (_ctx.cameraPos === 1)
      ? (_openBlock(), _createBlock(_component_RenderingRandselEdge, {
          key: 10,
          cameraPos: _ctx.cameraPos
        }, null, 8, ["cameraPos"]))
      : _createCommentVNode("", true),
    (_ctx.cameraPos === 1)
      ? (_openBlock(), _createBlock(_component_RenderingRandselBack, {
          key: 11,
          cameraPos: _ctx.cameraPos
        }, null, 8, ["cameraPos"]))
      : _createCommentVNode("", true),
    (_ctx.cameraPos === 1 && !_ctx.isPreview)
      ? (_openBlock(), _createBlock(_component_RenderingRandselName, {
          key: 12,
          cameraPos: _ctx.cameraPos
        }, null, 8, ["cameraPos"]))
      : _createCommentVNode("", true),
    (_ctx.cameraPos === 2)
      ? (_openBlock(), _createBlock(_component_RenderingRandselBody, {
          key: 13,
          cameraPos: _ctx.cameraPos
        }, null, 8, ["cameraPos"]))
      : _createCommentVNode("", true),
    (_ctx.cameraPos === 2)
      ? (_openBlock(), _createBlock(_component_RenderingRandselEdge, {
          key: 14,
          cameraPos: _ctx.cameraPos
        }, null, 8, ["cameraPos"]))
      : _createCommentVNode("", true),
    (_ctx.cameraPos === 2)
      ? (_openBlock(), _createBlock(_component_RenderingRandselBack, {
          key: 15,
          cameraPos: _ctx.cameraPos
        }, null, 8, ["cameraPos"]))
      : _createCommentVNode("", true)
  ]))
}